/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field[_ngcontent-%COMP%]{width:unset!important;height:unset!important}.mat-form-field-infix[_ngcontent-%COMP%]{padding-left:5px!important}.event-date-picker[_ngcontent-%COMP%]{width:108px!important}"];
export { styles as styles };
